"use client";
import { useProps } from "../../core/MantineProvider/use-props/use-props.mjs";
import { factory } from "../../core/factory/factory.mjs";
import { ModalBaseOverlay } from "../ModalBase/ModalBaseOverlay.mjs";
import { useModalContext } from "./Modal.context.mjs";
import Modal_module_default from "./Modal.module.mjs";
import { jsx } from "react/jsx-runtime";
//#region packages/@mantine/core/src/components/Modal/ModalOverlay.tsx
const ModalOverlay = factory((_props) => {
	const { classNames, className, style, styles, vars, ...others } = useProps("ModalOverlay", null, _props);
	return /* @__PURE__ */ jsx(ModalBaseOverlay, {
		...useModalContext().getStyles("overlay", {
			classNames,
			style,
			styles,
			className
		}),
		...others
	});
});
ModalOverlay.classes = Modal_module_default;
ModalOverlay.displayName = "@mantine/core/ModalOverlay";
//#endregion
export { ModalOverlay };

//# sourceMappingURL=ModalOverlay.mjs.map